import { defineStore } from 'pinia'
import { ref } from 'vue'

export type PaymentSupplier = 'wechat' | 'alipay'
export type PaymentEntry = 'manual' | 'insufficient'

export type PaymentRequest = {
  entry?: PaymentEntry
  creditsRequired?: number
  tipText?: string
  supplier?: PaymentSupplier
  from?: string
  onSuccess?: () => void | Promise<void>
}

export type PaymentResult =
  | { status: 'success'; orderId: string; skuId: string }
  | { status: 'cancel' }
  | { status: 'error'; message: string }

export const usePaymentModalStore = defineStore('paymentModal', () => {
  const open = ref(false)
  const request = ref<PaymentRequest | null>(null)

  let pending: { resolve: (r: PaymentResult) => void } | null = null

  function pay(req?: PaymentRequest) {
    request.value = req || null
    open.value = true
    return new Promise<PaymentResult>((resolve) => {
      pending = { resolve }
    })
  }

  function close(result: PaymentResult = { status: 'cancel' }) {
    open.value = false
    request.value = null
    const p = pending
    pending = null
    if (p) p.resolve(result)
  }

  function success(orderId: string, skuId: string) {
    close({ status: 'success', orderId, skuId })
  }

  function fail(message: string) {
    close({ status: 'error', message })
  }

  return { open, request, pay, close, success, fail }
})
